const normalizeString = (value) =>
  typeof value === 'string'
    ? value
        .trim()
        .toLowerCase()
        .replace(/[\s_-]+/g, '')
    : '';

const isSmartCropGloballyEnabled = () => {
  const value = normalizeString(process.env.NEXT_PUBLIC_DSM_SMARTCROP_ENABLED);
  return !['false', '0', 'off', 'no'].includes(value);
};

/**
 * Builds DSM image props and defaults DSM images to smart crop mode.
 * Set NEXT_PUBLIC_DSM_SMARTCROP_ENABLED=false to disable globally.
 */
export const buildDsmImageProps = ({
  src,
  alt = '',
  allowEmptySrc = false,
  enableSmartCrop,
  useNativeSmartCrop = false,
} = {}) => {
  const resolvedSrc = src;

  if (!allowEmptySrc && !resolvedSrc) {
    return undefined;
  }

  const imageProps = {
    src: resolvedSrc,
    alt,
  };

  const shouldEnableSmartCrop =
    typeof enableSmartCrop === 'boolean' ? enableSmartCrop : isSmartCropGloballyEnabled();

  if (shouldEnableSmartCrop) {
    if (useNativeSmartCrop) {
      imageProps['data-mode'] = 'smartcrop';
    } else {
      imageProps['data-smartcrop'] = 'true';
    }
  }

  return imageProps;
};
